import { render, staticRenderFns } from "./OfferTrades.vue?vue&type=template&id=5cc82b58&scoped=true&"
import script from "./OfferTrades.vue?vue&type=script&lang=js&"
export * from "./OfferTrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc82b58",
  null
  
)

export default component.exports